module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCERN:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What am I doing here? It is very simple. Your world is a mess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A mess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Your laws are inhuman. Your religion is without love. Your love is without religion and both, undirected, are useless. Your pastrami is stringy, and I am bored by your degeneracy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But what’s a mother to do? I’m here to bring it all back together again. I’ll come and straighten things out for you. I will choose an image here to do my work. To do your work. I shall spray your dusty corners with Lysol so you will find knowledge, stitch up those parts of your souls which have lost each other so that man knows what is womanly in him and woman knows what is manly in her. You hate, screw, war, starve and die without knowing me. The closets of your souls are empty of power and love. I do not like to come down here and work. There are no men here for me and I become, as a fish beyond the sea, hungry. And when I am overworked and hungry, I am mean. And when I am mean, I am destructive. So watch it. You are going to have to show me some respect this time, or you will all be impotent and once more the world will come grinding to an end and that end, as in your own grinding, which I have witnessed often, uncomfortably, will have no ecstasy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Excuse me. I begin my threats again. I must remember, this time, that if I want you to become more divine, I must be more humane.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Somehow, I will distribute the wonders of my baking to you, to heal and balance and restore to you the powers that once were yours in the antique. I have always been the connection between heaven and "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("earth, between man and woman, between thought and act, between everything. If your philosophers insist the world is a dichotomy, tell them that two plus two don’t make four unless something brings them together. The connection has been lost. But I’m back. Don’t worry. I am going to give you the secrets this time. You are not ready, but then you may never be and whatever will I do with them then? I must warn you I am jealous and selfish. However, I am really all that you have. I am one and my name is one and there shall be no one before me. I will forgive you anything, though, if you will love me. Cordially yours,")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("I remain,"), _c('br'), _vm._v("Your Mother/Harlot/Maiden/Wife"), _c('br'), _vm._v("(The Queen of Heaven)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("P.S. Call me Ishtar")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c87ce6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_Front02.vue
// module id = 81
// module chunks = 0